import { useQuery } from '@tanstack/react-query';
import { GetQrBidvVAEntity, BidvVirtualAccountService, GenQrBidvVADto } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type GetQrBidvVAQueryDTO = {
  endCode: string;
  enabled?: boolean;
};

export const useGetQrBidvVAQuery = (variables: GetQrBidvVAQueryDTO) => {
  const { enabled = true, endCode } = variables;
  const queryKey = [BidvVirtualAccountServiceQueryKeys.GET_QR, endCode];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetQrBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerGetQr(endCode),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!endCode,
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};